import React, { memo } from 'react';
import { CTASection } from '../components/CTASection';
import { ServiceCard } from '../components/ServiceCard';
import { Printer, Shirt, Palette, ScanLine, Flame, Zap, Sparkles, PenTool, CreditCard, Sticker, Car, Magnet, Flag, SignpostBig, Gift, Heart } from 'lucide-react';
export function Services() {
  const services = [{
    title: 'Screen Printing',
    description: 'Our core service. We use state-of-the-art automatic presses to deliver consistent, vibrant prints on t-shirts, hoodies, and more. Ideal for orders of 12+ pieces.',
    icon: <Printer data-id="element-1087" />,
    accentColor: 'yellow' as const,
    href: '/Screen-Printing'
  }, {
    title: 'Embroidery',
    description: 'We run multi-head embroidery machines capable of handling large orders quickly. Perfect for hats, polos, jackets, and bags that need a professional look.',
    icon: <Shirt data-id="element-1088" />,
    accentColor: 'teal' as const,
    href: '/Embroidery-Options'
  }, {
    title: 'Direct To Film',
    description: 'Advanced printing technology that transfers vibrant, detailed designs onto fabric. Perfect for intricate artwork and photorealistic images.',
    icon: <Zap data-id="element-1089" />,
    accentColor: 'pink' as const,
    href: '/Direct-to-Film'
  }, {
    title: 'Laser Engraving',
    description: 'Precision engraving on wood, metal, leather, and more. Perfect for personalized gifts, awards, and branded merchandise.',
    icon: <Sparkles data-id="element-1090" />,
    accentColor: 'yellow' as const,
    href: '/Laser-Cutting-Engraving'
  }, {
    title: 'Direct To Garment',
    description: 'Digital printing that dyes the fabric directly. Great for complex, full-color images and small runs. No minimums required.',
    icon: <Palette data-id="element-1091" />,
    accentColor: 'teal' as const,
    href: '/Direct-to-Garment'
  }, {
    title: 'Heat Transfer',
    description: 'Versatile heat-applied graphics for apparel and accessories. Ideal for names, numbers, and custom designs on various materials.',
    icon: <Flame data-id="element-1092" />,
    accentColor: 'pink' as const,
    href: '/Heat-Transfer'
  }, {
    title: 'Laser Etching',
    description: 'A unique process that burns a layer of fabric to create a tone-on-tone look. Works beautifully on fleece and performance fabrics.',
    icon: <ScanLine data-id="element-1093" />,
    accentColor: 'yellow' as const,
    href: '/Laser-Etching'
  }, {
    title: 'Laser Embroidery',
    description: 'Innovative laser technology combined with traditional embroidery for unique, dimensional designs on fabric.',
    icon: <Shirt data-id="element-1094" />,
    accentColor: 'teal' as const,
    href: '/Laser-Embroidery'
  }, {
    title: 'Graphic Design',
    description: 'Professional design services to bring your vision to life. From logos to full brand identities, our team creates stunning visuals.',
    icon: <PenTool data-id="element-1095" />,
    accentColor: 'pink' as const,
    href: '/Graphic-Design'
  }, {
    title: 'Business Cards & Labels',
    description: 'Professional business cards and product labels that make a lasting impression. Custom designs with quick turnaround.',
    icon: <CreditCard data-id="element-1096" />,
    accentColor: 'yellow' as const,
    href: '/Business-Cards-Product-Labels'
  }, {
    title: 'Custom Decals',
    description: 'High-quality custom decals designed to make your mark. Durable materials for indoor and outdoor use.',
    icon: <Sticker data-id="element-1097" />,
    accentColor: 'teal' as const,
    href: '/Custom-Decals'
  }, {
    title: 'Vehicle Decals',
    description: 'Turn your vehicle into a mobile billboard. Professional vehicle graphics and decals for cars, trucks, and vans.',
    icon: <Car data-id="element-1098" />,
    accentColor: 'pink' as const,
    href: '/Vehicle-Wall-and-Windows'
  }, {
    title: 'Vehicle Magnets',
    description: 'Removable vehicle magnets for flexible advertising. Perfect for businesses that need temporary branding solutions.',
    icon: <Magnet data-id="element-1099" />,
    accentColor: 'yellow' as const,
    href: '/Vehicle-Magnets-Business-Advertising'
  }, {
    title: 'Banners',
    description: 'Eye-catching banners for events, promotions, and displays. Durable materials in custom sizes to fit your needs.',
    icon: <Flag data-id="element-1100" />,
    accentColor: 'teal' as const,
    href: '/Banners'
  }, {
    title: 'Yard Signs',
    description: 'Weather-resistant yard signs for real estate, events, and promotions. Custom designs with fast production.',
    icon: <SignpostBig data-id="element-1101" />,
    accentColor: 'pink' as const,
    href: '/Yard-Signs'
  }, {
    title: 'Promotional Products',
    description: 'Wide selection of branded promotional items to market your business. From pens to drinkware and beyond.',
    icon: <Gift data-id="element-1102" />,
    accentColor: 'yellow' as const,
    href: '/services/promotional-products'
  }, {
    title: 'Personalized Products',
    description: 'Custom personalized items for gifts, events, and special occasions. Make it memorable with custom touches.',
    icon: <Heart data-id="element-1103" />,
    accentColor: 'teal' as const,
    href: '/Personalized-Products'
  }];
  return <div className="pt-12 pb-20" data-id="element-1104">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center mb-16" data-id="element-1105">
        <h1 className="text-4xl font-bold text-gray-900 mb-6" data-id="element-1106">Our Services</h1>
        <p className="text-xl text-gray-600" data-id="element-1107">
          Comprehensive customization solutions for every need.
        </p>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-20" data-id="element-1108">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1109">
          {services.map((service, index) => <ServiceCard key={index} {...service} data-id="element-1110" />)}
        </div>
      </div>

      <CTASection data-id="element-1111" />
    </div>;
}